import { Scope, Severity } from '@sentry/react';

import {
  configureSentry,
  configureSentryLogger,
  configureSentrySync,
} from './sentry';

export const TAG_GRAPHQL_SENTRY: [string, string] = ['service', 'graphql'];

export const setTag = (scope: Scope) => {
  scope.setTag(...TAG_GRAPHQL_SENTRY);
};

export const configureGraphQLSentry = (severity?: Severity) => {
  const { withSentry, scope } = configureSentry(severity);
  setTag(scope);
  return withSentry;
};

export const configureGraphQLSentrySync = (severity?: Severity) => {
  const { withSentry, scope } = configureSentrySync(severity);
  setTag(scope);
  return withSentry;
};

export const configureGraphQLSentryLogger = (
  prefix?: string,
  severity?: Severity,
) => {
  const { logger, scope } = configureSentryLogger(severity);
  setTag(scope);
  return (...data: any[]) => {
    if (typeof prefix === 'undefined') return logger(...data);
    return logger(prefix, ...data);
  };
};

export const withGraphQLErrorSentry = configureGraphQLSentry(Severity.Error);
export const withGraphQLWarningSentry = configureGraphQLSentry(
  Severity.Warning,
);
